<template>
    <div v-if="getUserType == 2 || (subsectionStructure.columns && Object.keys(subsectionStructure.columns).length)"
        class="subsection_table_holder">
        <div class="subsection_table_tools">
            <div class="table_style">
                <!-- <input type="checkbox" v-model="table_style">
                <label for="table_style" style="cursor: pointer;">Alternativni pogled</label> -->
                
                <input type="checkbox" id="table_style" v-model="filter_options">
                <label for="table_style" class="pointer">Možnost filtriranja</label>
            </div>

            <div v-if="hasActiveColumnFilters" class="filter_status">
                Prikazano {{ filteredRowKeys.length }} od {{ totalRowCount }} vrstic
            </div>

            <!-- Button for copying table data in other facutlies if full width (when levels are not visible - only one level) -->
            <div v-if="getUserType < 3 && active_subsection_id != null && subsectionStructure.columns &&
                Object.keys(subsectionStructure.columns).length && !tableHasOnlyFilesOrEmpty /* && active_subsection_data.predefined == 0 */ &&
                ((!section_submitted && deadline_not_closed) || getUserType == 2)" class="button_holder">
                <div class="button gray" @click="showModal({ component: 'sections/ImportDataSubsectionTable' })">
                    Uvoz podatkov v tabelo
                </div>
            </div>
        </div>

        <!-- Table -->
        <div class="subsection_table_table" :class="{ alternative: table_style }">

            <!-- Table header row -->
            <div class="row header">
                <!-- Table columns -->
                <div class="column column_header"
                    :class="{ highlighted: column.highlighted == 1, origin_year: column.type == 7 }"
                    v-for="column in subsectionStructure.columns" :key="column.id">

                    <span class="text">
                        {{ column.name }}
                    </span>

                    <span class="description">
                        {{ column.description }}
                    </span>

                    <div class="row_header multiple_columns">
                        <div class="row_header_item_group wrap">
                            <font-awesome-icon v-if="column.mandatory > 0" class="icon"
                                :icon="['fas', 'exclamation-triangle']" title="Obvezno" />
                            <font-awesome-icon v-if="getUserType == 2 && column.disabled > 0" class="icon"
                                :icon="['fas', 'ban']" title="Onemogočeno urejanje" />
                            <font-awesome-icon v-if="column.personal_data > 0" class="icon"
                                :icon="['fas', 'user-shield']" title="Osebni podatek" />

                            <span class="type row_child_header">
                                ({{ columnTypeText(column.type) }})
                            </span>
                        </div>

                        <div class="row_header_item_group">
                            <div v-if="column.type == 5" class="as_link icon row_child_header" title="Prenesi vse"
                                @click="exportFilesColumn({ column_id: column.id })">
                                <font-awesome-icon :icon="['fas', 'download']" />
                            </div>

                            <div v-if="column.type == 5 && getUserType == 2" class="as_link icon row_child_header zip"
                                title="Prenesi vse (vse članice)"
                                @click="exportFilesColumn({ column_id: column.id, all: true })">
                                <font-awesome-icon :icon="['fas', 'download']" />
                            </div>

                            <div class="as_link icon edit row_child_header" title="Uredi stolpec"
                                v-if="getUserType == 2" @click="showModal({
                                    component: 'sections/EditColumnSectionDetailTable',
                                    data: {
                                        name: column.name, description: column.description, column_id: column.id, order_number: column.order_number,
                                        mandatory: column.mandatory, type: column.type, disabled_column: column.disabled, highlighted: column.highlighted,
                                        personal_data: column.personal_data, dropdown_items: getColumnDropdownItems(column.dropdown_items)
                                    }
                                })">
                                <font-awesome-icon :icon="['fas', 'pencil-alt']" />
                            </div>

                            <div class="as_link icon remove row_child_header" title="Pobriši stolpec"
                                v-if="getUserType == 2"
                                @click="showModal({ component: 'sections/DeleteColumnSectionDetailTable', data: { column_id: column.id } })">
                                <font-awesome-icon :icon="['far', 'trash-alt']" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Add column -->
                <div class="column add-column" title="Dodaj stolpec" v-if="getUserType == 2"
                    @click="showModal({ component: 'sections/CreateColumnDetailTable' })">
                    <div class="as_link icon">
                        <font-awesome-icon :icon="['far', 'plus-square']" /> Dodaj stolpec
                    </div>
                </div>

                <!-- Tools table columns -->
                <div class="column tools"
                    v-if="getUserType != 3 && (((!section_submitted && deadline_not_closed) || getUserType > 1) &&
                        !hide_editing_worksection_temp && (active_subsection_data.disable_rows_edit == 0 || getUserType > 1))">
                </div>
            </div>

            <!-- Table filter row -->
            <div class="row filter" v-show="filter_options">
                <div class="column"
                    :class="{ highlighted: column.highlighted == 1, origin_year: column.type == 7 }"
                    v-for="column in subsectionStructure.columns" :key="'filter-' + column.id">
                    <input type="text" class="column_filter_input"
                        :value="columnFilters[column.id] || ''"
                        @input="setColumnFilter(column.id, $event.target.value)"
                        placeholder="Filtriraj" title="Filtriraj vrstice" />
                </div>

                <div class="column add-column" v-if="getUserType == 2"></div>

                <div class="column tools" v-if="getUserType != 3 && (((!section_submitted && deadline_not_closed) || getUserType == 2) && !hide_editing_worksection_temp &&
                    (active_subsection_data.disable_rows_edit == 0 || getUserType == 2))">
                    <div class="as_link icon" title="Počisti filtre" v-if="hasActiveColumnFilters"
                        @click="clearColumnFilters">
                        <font-awesome-icon :icon="['fas', 'filter-circle-xmark']" />
                    </div>
                </div>
            </div>

            <!-- Table data rows -->
            <div class="row data" :class="{ highlight_row: check_highlight_row(key) }"
                v-for="key in filteredRowKeys" :key="key">
                <!-- Table columns -->
                <div class="column" :class="{ highlighted: column.highlighted == 1, origin_year: column.type == 7 }"
                    v-for="column in subsectionStructure.columns" :key="column.id">
                    <div v-if="column.type == 1">
                        <textarea rows="4" :value="data[key][column.id]"
                            :disabled="getUserType == 3 || ((getUserType != 2 && column.disabled == 1) || !((!section_submitted && deadline_not_closed) || getUserType == 2))"
                            @change="cellChanged(key, column, $event)"></textarea>
                    </div>

                    <div v-if="column.type == 2">
                        <input type="text" class="input_number" :value="data[key][column.id]"
                            :disabled="getUserType == 3 || ((getUserType != 2 && column.disabled == 1) || !((!section_submitted && deadline_not_closed) || getUserType == 2))"
                            @change="cellChanged(key, column, $event)" @keypress="isNumber($event)"
                            @paste="isNumberPaste($event, key, column)">
                    </div>

                    <div class="select_cell" v-if="column.type == 3">
                        <select :value="data[key][column.id]"
                            :disabled="getUserType == 3 || ((getUserType != 2 && column.disabled == 1) || !((!section_submitted && deadline_not_closed) || getUserType == 2))"
                            @change="cellChanged(key, column, $event)">
                            <option>DA</option>
                            <option>NE</option>
                            <option>/</option>
                            <option v-if="getUserType == 2" value=""></option>
                        </select>
                    </div>

                    <div v-if="column.type == 4">
                        <div class="flatpickr" data-wrap="true">
                            <Flatpickr :model-value="isSlDate(data[key][column.id]) ? data[key][column.id] : null"
                                @on-change="(_, dateStr) => cellChanged(key, column, null, dateStr || '')"
                                :config="fpConfig"
                                :disabled="getUserType == 3 || ((getUserType != 2 && column.disabled == 1) || !((!section_submitted && deadline_not_closed) || getUserType == 2))">
                            </Flatpickr>
                            <button @click="cellChanged(key, column, null, '')"
                                :disabled="getUserType == 3 || ((getUserType != 2 && column.disabled == 1) || !((!section_submitted && deadline_not_closed) || getUserType == 2)) || !data[key][column.id]"
                                title="Počisti datum">
                                <font-awesome-icon :icon="['fas', 'times']" />
                            </button>
                        </div>

                    </div>

                    <div v-if="column.type == 5">
                        <div class="button disabled" title="Naloži datoteko"
                            v-if="!data[key][column.id] && (getUserType == 3 || (((getUserType != 2 && column.disabled == 1) || !((!section_submitted && deadline_not_closed) || getUserType == 2))))">
                            Naloži
                        </div>

                        <div class="button gray" title="Naloži datoteko" v-else-if="!data[key][column.id]" @click="showModal({
                            component: 'sections/EditSectionDetailTableAttachments',
                            data: { row_id: key, col_id: column.id, mandatory: column.mandatory }
                        })">
                            Naloži
                        </div>

                        <div class="upload_data"
                            v-if="data[key][column.id] !== undefined && data[key][column.id] !== ''">
                            <div v-if="getUserType != 3 && (getUserType == 2 || (column.disabled == 0 && (!section_submitted && deadline_not_closed)))"
                                class="as_link upload_name gray floatLeft" title="Uredi priponko" @click="showModal({
                                    component: 'sections/EditSectionDetailTableAttachments',
                                    data: { file_data: data[key][column.id], row_id: key, col_id: column.id, mandatory: column.mandatory }
                                })">
                                <font-awesome-icon class="font-inherit mr5 center-vertical"
                                    :icon="['fas', 'pencil-alt']" />
                                {{ data[key][column.id].name }}
                            </div>
                            <div class="as_link icon left_margin floatLeft" title="Shrani priponko">
                                <a v-bind:href="data[key][column.id].file_url" target="_blank"><font-awesome-icon
                                        :icon="['fas', 'download']" /></a>
                            </div>
                        </div>
                    </div>

                    <div class="select_cell" v-if="column.type == 6 || column.type == 8">
                        <select :value="getSelectDisplayValue(key, column)"
                            :disabled="getUserType == 3 || ((getUserType != 2 && column.disabled == 1) || !((!section_submitted && deadline_not_closed) || getUserType == 2))"
                            @change="cellChanged(key, column, $event)">
                            <option v-for="(value, index) in column.dropdown_items" :key="index"
                                :title="getStatusOptionTitle(value)">{{ value }}</option>
                            <option v-if="getUserType == 2" value=""></option>
                        </select>
                        <textarea class="textarea_other"
                            v-if="column.type == 8 && column.dropdown_items && shouldShowTextarea(key, column)"
                            rows="2" :value="getTextareaValue(key, column)"
                            :disabled="getUserType == 3 || ((getUserType != 2 && column.disabled == 1) || !((!section_submitted && deadline_not_closed) || getUserType == 2))"
                            @change="cellChanged(key, column, $event)"
                            placeholder="Vnesite besedilo"></textarea>
                    </div>

                    <!-- Izvorno leto vrstice -->
                    <div v-if="column.type == 7">
                        <span>
                            {{ (transferred_rows[key] ? transferred_rows[key].input_year : '') }}
                        </span>
                    </div>
                </div>

                <!-- Add column - empty column -->
                <div class="column add-column" v-if="getUserType == 2">
                </div>

                <!-- Tools table columns - delete row -->
                <div class="column tools" v-if="getUserType != 3 && (((!section_submitted && deadline_not_closed) || getUserType == 2) && !hide_editing_worksection_temp &&
                    (active_subsection_data.disable_rows_edit == 0 || getUserType == 2))">
                    <div class="as_link icon" title="Pobriši vrstico" v-if="!isLastRow()"
                        @click="showModal({ component: 'sections/DeleteRowSectionDetailTable', data: { mandatory_columns: num_mandatory_columns, row_id: key } })">
                        <font-awesome-icon :icon="['far', 'trash-alt']" />
                    </div>
                </div>
            </div>

            <!-- Table data - add row -->
            <div class="row add-data">
                <div class="as_link icon" title="Dodaj vrstico" @click="addTableRow()" v-if="getUserType != 3 && (subsectionStructure.columns && ((!section_submitted && deadline_not_closed) || getUserType == 2) && !hide_editing_worksection_temp &&
                    (active_subsection_data.disable_rows_edit == 0 || getUserType == 2))">
                    <font-awesome-icon :icon="['far', 'plus-square']" /> Dodaj vrstico
                </div>
            </div>

        </div>
    </div>
</template>


<script>
import { mapActions } from 'vuex';
import { Slovenian as slLocale } from 'flatpickr/dist/l10n/sl.js'
import VueFlatpickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    name: 'SectionsDetailTable',
    components: {
        Flatpickr: VueFlatpickr
    },
    data: function () {
        return {
            data: {},
            table_style: false,
            filter_options: false,
            num_mandatory_columns: 0,
            num_columns: 0,
            fpConfig: {
                locale: slLocale,
                dateFormat: 'j.n.Y',
                altInput: false,
                disableMobile: true,
            },
            columnFilters: {},
        }
    },
    watch: {
        active_subsection_id() {
            this.columnFilters = {};
        },
        filter_options(value) {
            if (!value) {
                this.clearColumnFilters();
            }
        },
    },
    props: {
        deadline_not_closed: {
            type: Boolean,
            default: false
        },
        section_submitted: {
            type: Boolean,
            default: false
        }
    },
    computed: {

        // Selected subsection object with structure (table columns, input types...)
        subsectionStructure() {
            let subsectionStructure = this.$store.getters.subsection_data.columns;
            this.num_mandatory_columns = 0;
            this.num_columns = 0;

            //count all columns that are mandatory for this subsection/table
            for (let column in subsectionStructure) {
                this.num_columns++;
                this.num_mandatory_columns += parseInt(subsectionStructure[column].mandatory);
            }

            return { columns: subsectionStructure };
        },

        //check if table has only files or is empty
        tableHasOnlyFilesOrEmpty() {
            for (let column of Object.values(this.subsectionStructure.columns)) {
                if (column.type != "5") return false;
            }
            return true;
        },

        // Selected subsection object with data (inserted table data)
        subsectionData() {
            this.data = this.$store.getters.subsection_data.data;
            return { rows: this.data };
        },

        // Get list of transferred rows (last year measures)
        transferred_rows() {
            return this.$store.getters.subsection_data.transferred_rows;
        },

        // Get loged user type
        getUserType() {
            return this.$store.state.user.type;
        },

        active_subsection_id() {
            return this.$store.getters.active_subsection_id;
        },

        //tempbadworksections1
        hide_editing_worksection_temp() {
            if (66 < this.active_subsection_id && this.active_subsection_id < 72 && this.getUserType != 2)
                return true;
            return false;
        },

        section_level() {
            let section_level = this.$store.getters.section_level;
            return section_level;
        },

        getSectionStatistics() {
            let section_id = this.$route.params.section_id;
            return this.$store.getters.sections_statistics[section_id];
        },

        // Selected subsection data
        active_subsection_data() {
            let level = this.$store.getters.section_level;
            let subsections = this.$store.getters.subsections_data[level];
            let active_subsection = this.$store.getters.active_subsection_id;
            return subsections ? subsections[active_subsection] : {};
        },

        getYear() {
            return this.$store.getters.year;
        },

        totalRowCount() {
            return Object.keys(this.subsectionData.rows || {}).length;
        },

        hasActiveColumnFilters() {
            return Object.values(this.columnFilters).some(
                (value) => (value || '').trim() !== ''
            );
        },

        filteredRowKeys() {
            const rows = this.subsectionData.rows;
            if (!rows) return [];

            const columns = this.subsectionStructure.columns;
            if (!columns || !Object.keys(columns).length) {
                return Object.keys(rows);
            }

            return Object.keys(rows).filter((rowKey) =>
                Object.values(columns).every((column) => {
                    const query = (this.columnFilters[column.id] || '').trim().toLowerCase();
                    if (!query) return true;
                    return this.getCellFilterText(rowKey, column).toLowerCase().includes(query);
                })
            );
        },

    },
    methods: {
        ...mapActions([
            'showModal',
            'addSubsectionTableRow',
            'updateCell',
            'updateProgressBarSimple',
            'exportFilesColumn'
        ]),

        //tempbadworksections1
        special_column_worksection_temp(id_column) {
            let disabled_columns_ids = [390, 391, 392, 393, 394, 401, 402, 403, 404, 406, 407, 408, 409, 412, 414];

            if (disabled_columns_ids.includes(parseInt(id_column)))
                return true
            return false
        },

        getStatusOptionTitle(option) {
            const targetStrings = ['delno realiziran', 'ostaja na ravni predloga'];
            const lowerLabel = option.toLowerCase();
            return targetStrings.some(str => lowerLabel.includes(str))
                ? 'Ukrep bo samodejno prenesen v naslednje obdobje poročanja'
                : '';
        },

        addTableRow() {
            this.addSubsectionTableRow({ mandatory_columns: this.num_mandatory_columns, all_columns: this.num_columns });
        },

        setColumnFilter(columnId, value) {
            this.columnFilters = { ...this.columnFilters, [columnId]: value };
        },

        clearColumnFilters() {
            this.columnFilters = {};
        },

        getCellFilterText(rowKey, column) {
            const raw = this.data[rowKey]?.[column.id];

            if (column.type == 5) {
                return raw?.name ?? '';
            }

            if (column.type == 7) {
                return String(this.transferred_rows?.[rowKey]?.input_year ?? '');
            }

            if (column.type == 6 || column.type == 8) {
                const parts = [
                    this.getSelectDisplayValue(rowKey, column),
                    this.getTextareaValue(rowKey, column),
                ].filter((part) => part !== '' && part != null);
                return parts.join(' ');
            }

            return raw == null ? '' : String(raw);
        },

        // Get column type text
        columnTypeText(type) {

            let text = '';
            if (type == 1)
                text = 'Besedilo';
            else if (type == 2)
                text = 'Število';
            else if (type == 3)
                text = 'Da / Ne';
            else if (type == 4)
                text = 'Datum';
            else if (type == 5)
                text = 'Datoteka';
            else if (type == 6)
                text = 'Roleta';
            else if (type == 8)
                text = 'Roleta - drugo';
            else
                text = 'Drugo';

            return text;
        },

        // When cell is changed
        cellChanged(row_id, column, event, forced_value = false) {
            let column_id = column.id;
            let mandatory = column.mandatory;

            // forced_value can be '' (clear), so check !== false, not truthiness
            const newValue = (forced_value !== false)
                ? forced_value
                : (event?.target?.value ?? '');

            let oldValue = this.data[row_id][column_id];

            this.data[row_id][column_id] = newValue;

            if (oldValue == '')
                this.updateProgressBarSimple({ mandatory: mandatory, edit: 1 });
            else if (newValue == '')
                this.updateProgressBarSimple({ mandatory: mandatory, edit: -1 });

            if (this.getSectionStatistics.submitted == '0') {
                this.updateCell({ row_id: row_id, column_id: column_id, value: newValue });
            }
        },

        // Check if it is the only row in table
        isLastRow() {
            let rowCount = Object.keys(this.subsectionData.rows).length;

            if (rowCount < 2)
                return true;
            else
                return false;
        },

        getColumnDropdownItems(dropdown_items) {
            if (dropdown_items) {
                return Object.values(dropdown_items);
            }
            return [];
        },

        // Check if value exists in dropdown items
        valueExistsInDropdown(value, dropdown_items) {
            if (!dropdown_items) return false;
            return Object.values(dropdown_items).includes(value);
        },

        // Get the display value for select - if value doesn't exist in options, show last option
        getSelectDisplayValue(key, column) {
            const currentValue = this.data[key][column.id];
            if (!column.dropdown_items) return currentValue;
            
            // If value is empty or undefined, return empty to show no selection
            if (currentValue === undefined || currentValue === null || currentValue === '') {
                return '';
            }
            
            const dropdownValues = Object.values(column.dropdown_items);
            const lastOption = dropdownValues.slice(-1)[0];
            
            // If current value doesn't exist in options, return last option
            if (column.type == 8 && !this.valueExistsInDropdown(currentValue, column.dropdown_items)) {
                return lastOption;
            }
            
            return currentValue;
        },

        // Check if textarea should be shown
        shouldShowTextarea(key, column) {
            if (!column.dropdown_items) return false;
            
            const currentValue = this.data[key][column.id];
            
            // Don't show textarea if value is empty or undefined
            if (currentValue === undefined || currentValue === null || currentValue === '') {
                return false;
            }
            
            const dropdownValues = Object.values(column.dropdown_items);
            const lastOption = dropdownValues.slice(-1)[0];
            
            // Show textarea if value equals last option OR if value doesn't exist in options
            return currentValue == lastOption || !this.valueExistsInDropdown(currentValue, column.dropdown_items);
        },

        // Get textarea value - if value doesn't exist in options, show that value, otherwise empty
        getTextareaValue(key, column) {
            const currentValue = this.data[key][column.id];
            if (!column.dropdown_items) return '';
            
            const dropdownValues = Object.values(column.dropdown_items);
            const lastOption = dropdownValues.slice(-1)[0];
            
            // If value doesn't exist in options, show that value in textarea
            if (!this.valueExistsInDropdown(currentValue, column.dropdown_items)) {
                return currentValue;
            }
            
            return '';
        },

        //check if row needs to be highlighted
        check_highlight_row(row_id) {
            // only highlight if row is transferred and is the same year as current
            return (this.transferred_rows ? (Object.keys(this.transferred_rows).includes(row_id) && this.transferred_rows[row_id].input_year == this.getYear) : false);
        },

        // Check if input is a number or comma (for number cell)
        isNumber(evt) {
            evt = (evt) ? evt : window.event;

            var charCode = (evt.which) ? evt.which : evt.keyCode;

            // Check if text is selected (user is replacing selected text)
            const hasSelection = evt.target.selectionStart !== evt.target.selectionEnd;

            // Block input if the value is already a single slash, but allow if text is selected (replacement)
            if (evt.target.value === '/' && !hasSelection) {
                evt.preventDefault(); // Prevent any additional input
            }

            // If slash '/', allow only if the input is empty, and no further input if value is already a slash
            if (charCode == 47) { // 47 is the charCode for '/'
                if (evt.target.value !== '' && !hasSelection) {
                    evt.preventDefault(); // Block input if value is not empty and no text is selected
                }
                return true; // Allow slash if value is empty or text is selected
            }

            //if comma, ignore if comma already exist, if string is empty, or if all text is selected (would result in comma as first char)
            const allTextSelected = hasSelection && evt.target.selectionStart === 0 && evt.target.selectionEnd === evt.target.value.length;
            if (charCode == 44 && (evt.target.value.includes(',') || evt.target.value == '' || allTextSelected))
                evt.preventDefault();
            //some basic keys (delete, backspace,... + numbers + comma for decimal)
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 44)
                evt.preventDefault();
            else
                return true;
        },

        // Check if input is a number or comma (for number cell)
        isNumberPaste(evt, row_id, column) {
            //get paste value
            let paste = (evt.clipboardData || window.clipboardData).getData('text');
            let result = paste;

            evt = (evt) ? evt : window.event;
            evt.preventDefault();

            //let numbers = paste.replace(/[^0-9,]/g, "");

            //if paste contains anithing else than 0-9., cancle it
            if (/[^0-9.,]/g.test(paste) || paste.charAt(0) == ',' || paste.charAt(0) == '.'
                || paste.substr(-1) == ',' || paste.substr(-1) == '.') {
                return;
            }
            //paste contains only 0-9,.
            else {
                //remove all dots
                if (paste.includes('.')) {
                    result = paste.replaceAll('.', '');
                }
                //only leave first comma, remove others
                if ((paste.match(/,/g) || []).length > 1) {
                    let index = 0;
                    result = paste.replace(/\,/g, (item) => (!index++ ? item : ""));
                }

                //force cell change (because of preventdefault(), value in event.target is not changed)
                this.cellChanged(row_id, column, evt, result);
            }
        },

        isSlDate(s) {
            // 7.8.2025 or 07.08.2025 etc.
            return typeof s === 'string' && /^\d{1,2}\.\d{1,2}\.\d{4}$/.test(s)
        },
    }
}
</script>


<style lang="scss" scoped>
/* Transicije */
.fade-enter-active {
    transition: opacity 0.3s;
}

.fade-leave-active {
    transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
